import { JSX } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { MdOutlineWifiOff } from 'react-icons/md';
import { useShallow } from 'zustand/shallow';
import { useIsOnline } from '../hooks/connection.hook';
import { useNavigation } from '../hooks/navigation.hook';
import { useScroll } from '../hooks/scroll.hook';
import { useAppStore } from '../stores/app.store';

export function Header(): JSX.Element {
  const { navigate } = useNavigation();
  const { scrollsTop } = useScroll();
  const isOnline = useIsOnline();

  const [title, titleSize, backButton, onBack, headerComponent, isDark] = useAppStore(
    useShallow((s) => [s.title, s.titleSize, s.backButton, s.onBack, s.headerComponent, s.isDark]),
  );

  const shadow = isDark ? 'shadow-[0_4px_6px_-1px_rgba(0,0,0,0.6)]' : 'shadow-md';

  return !title && !backButton ? (
    <div className="mt-5"></div>
  ) : (
    <header
      className={`sticky top-0 bg-base-200 py-3 transition-shadow duration-300 ease-in-out z-10 ${
        scrollsTop ? shadow : ''
      }`}
    >
      <div className="width-limiter px-5 ">
        <div className={`relative flex gap-2 ${backButton ? 'justify-between' : 'justify-around'}`}>
          <button className={`cursor-pointer ${!backButton && 'invisible'}`} onClick={onBack ?? (() => navigate(-1))}>
            <FaArrowLeft size={'1.5rem'} />
          </button>

          <h1
            className={`${titleSize ?? 'text-4xl'} flex-grow-1 overflow-hidden font-bold hyphens-auto text-center ${
              !title && 'invisible'
            }`}
          >
            {title ?? 'no title'}
          </h1>

          <button className={`text-error/70 ${isOnline && 'invisible'}`}>
            <MdOutlineWifiOff size={'1.5rem'} />
          </button>
        </div>

        {headerComponent && <div className="mt-2">{headerComponent}</div>}
      </div>
    </header>
  );
}
